import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { PhoneListService } from '@pbx/services/PhoneListService';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => PhoneListService.getList(params)
    }
  },
  true
);
